import { InspectionWorkflow, InspectionQuestion } from "../types/inspectionWorkflow";
import { InspectionResult } from "src/services/inspectionService";
import { getCheckpoints } from "./checkpointExtractor";

/** Progress-card metrics derived from a draft's saved results. */
export interface DraftProgress {
    /** Rounded % of workflow checkpoints that have at least one result. */
    percentComplete: number;
    /** Count of distinct non-null container ids captured so far. */
    containersInspected: number;
}

/**
 * Computes the Resume Draft screen's progress-card metrics from the active
 * workflow and the draft's saved results. An iterable checkpoint counts as
 * complete as soon as any single container has a result. Pure and
 * side-effect free.
 */
export const computeDraftProgress = (
    workflow: InspectionWorkflow,
    questions: InspectionQuestion[],
    results: InspectionResult[]
): DraftProgress => {
    const checkpoints = getCheckpoints(workflow, questions);
    const totalCheckpoints = checkpoints.length;

    const capturedQuestionIds = new Set(results.map((r) => r.questionId));
    const completedCheckpoints = checkpoints.filter((c) =>
        capturedQuestionIds.has(c.question_id)
    ).length;

    const percentComplete =
        totalCheckpoints === 0
            ? 0
            : Math.round((completedCheckpoints / totalCheckpoints) * 100);

    const containersInspected = new Set(
        results
            .map((r) => r.objectId)
            .filter((id): id is string => !!id)
    ).size;

    return { percentComplete, containersInspected };
};
